import axios from 'axios'
import Vue from 'vue'

var baseUrl = '/apiseckill/v1';
var userBaseUrl = '/apiu/v1';

if (process.env.NODE_ENV === 'production') {
    baseUrl = '/apiseckill/v1';
    userBaseUrl = '/apiu/v1';
}
axios.defaults.timeout = 500000;

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        // config.data = JSON.stringify(config.data);
        // config.headers = {
        // }
        // if(token){
        //   config.params = {'token':token}
        // }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

//http response 拦截器
axios.interceptors.response.use(
    response => {
        // if (response.data.code == '1402') {
        //     window.location.href = "/login.html"
        // }
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)

//post请求 json 无参数无错误返回
var postNDNF = function postNDNF(type, url, success) {
    postNF(type, url, {}, success)
}

//post请求 json 有参数无错误返回
var postNF = function postNF(type, url, data, success) {
    post(type, url, data, success, response => {
        Vue.prototype.$notify.error(response.msg);
    })
}

//post请求 formData 无参数无错误返回
var postFormNDNF = function postFormNDNF(type, url, success) {
    postFormNF(type, url, {}, success)
}

//post请求 formData 有参数无错误返回
var postFormNF = function postFormNF(type, url, data, success) {
    postForm(type, url, data, success, response => {
        Vue.prototype.$notify.error(response.msg);
    })
}

var postForm = function postForm(type, url, data, success, failure) {
    // console.log(JSON.stringify(data))
    let formData = new FormData();
    for (let i in data) {
        formData.append(i, data[i]);
    }
    post(type, url, formData, success, failure)
}

var post = function post(type, url, data, success, failure) {
    switch (type) {
        case 1://转学
            axios.defaults.baseURL = baseUrl
            break;
        case 2://用户
            axios.defaults.baseURL = userBaseUrl
            break;
    }
    // console.log(axios.defaults.baseURL + ":" + url + ":" + JSON.stringify(data));
    var promise = new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
                Vue.prototype.$message.close();
                Vue.prototype.$global.isLoading = false
            }, err => {
                Vue.prototype.$message.close()
                Vue.prototype.$global.isLoading = false
                reject(err)
                failure('网络错误')
            })
    });
    promise.then(response => {
        // console.log(response);
        if (response.code == 'ok' || response.code == 0 || response.code == 200) {
            success(response);
        } else {
            failure(response)
            // if (response.code == '1402') {
            //     window.location.href = "/sgx_preengage_front/#/schoolHome/login"
            //     return;
            // }
            // // if (response.code == '1401') {
            // //     window.location.href = "/sgx_transferred_front/#/nopermission"
            // //     return;
            // // }
            // if (response.code == '1403') {
            //     Vue.prototype.$notify.error({title:'当前操作无权限'})
            //     return;
            // }
            
            return;
        }
    })
}

var getNDNF = function getNDNF(type, url, success) {
    get(type, url, {}, success, response => {
        Vue.prototype.$notify.error({ title: (response.msg != undefined) ? response.msg : response });
    })
}

var getNF = function getNF(type, url, data, success) {
    get(type, url, data, success, response => {
        Vue.prototype.$notify.error({ title: (response.msg != undefined) ? response.msg : response });
    })
}

var get = function get(type, url, data, success, failure) {
    switch (type) {
        case 1://转学
            axios.defaults.baseURL = baseUrl
            break;
        case 2://用户
            axios.defaults.baseURL = userBaseUrl
            break;
    }
    // console.log(url + ":" + JSON.stringify(data))
    var promise = new Promise((resolve, reject) => {
        // axios.get(url,data)
        axios({
            method: 'get',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            params: data,
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                Vue.prototype.$message.close()
                reject(err)
                failure('网络错误')
            })
    });
    promise.then(response => {
        // console.log(response);
        if (response.code == 'ok' || response.code == 0 || response.code == 200) {
            success(response);
        } else {
            failure(response)
            // if (response.code == '1402') {
            //     window.location.href = "/sgx_preengage_front/#/schoolHome/login"
            //     return;
            // }
            // // if (response.code == '1401') {
            // //     window.location.href = "/sgx_transferred_front/#/nopermission"
            // //     return;
            // // }
            // if (response.code == '1403') {
            //     Vue.prototype.$notify.error({title:'当前操作无权限'})
            //     return;
            // }
            
            return;
        }
    })
}


var downloadND = function downloadND(url, name, success = undefined) {
    download(url, {}, name, success)
}

var downloadForm = function downloadForm(url, data, name, success = undefined) {
    let formData = new FormData();
    for (let i in data) {
        formData.append(i, data[i]);
    }
    download(url, formData, name, success)
}

var download = function download(url, data, name, success = undefined) {
    axios.defaults.baseURL = baseUrl;
    // console.log(url + ":" + JSON.stringify(data))
    var promise = new Promise((resolve, reject) => {
        axios.post(url, data, {
            responseType: 'blob'
        })
            .then(response => {
                Vue.prototype.$message.close();
                Vue.prototype.$global.isLoading = false
                resolve(response.data);
            }, err => {
                Vue.prototype.$message.close();
                Vue.prototype.$global.isLoading = false
                reject(err)
                Vue.prototype.$notify.error({ title: '网络错误' });
            })
    });
    promise.then(response => {
        // console.log(response)
        if (response.size == 0) {
            Vue.prototype.$notify.warning({ title: '当前数据为空' });
            return;
        }
        if (response.size < 15) {
            Vue.prototype.$notify.warning({ title: '当前无权限' });
            return;
        }
        if (success != undefined) {
            success();
            return;
        }
        let dowloadUrl = window.URL.createObjectURL(new Blob([response]), { 'type': 'application/vnd.ms-excel' })
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = dowloadUrl
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()

    })
}

var downloadFile = function downloadFile(url, name) {
    axios.defaults.baseURL = baseUrl;
    var promise = new Promise((resolve, reject) => {
        axios.get(url, {
            responseType: 'blob'
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    });
    promise.then(response => {
        // console.log(response)
        let dowloadUrl = window.URL.createObjectURL(new Blob([response]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = dowloadUrl
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()

    })

}

export default {
    postNDNF,
    postNF,
    postFormNDNF,
    postFormNF,
    postForm,
    post,
    getNDNF,
    getNF,
    get,
    downloadND,
    downloadForm,
    download,
    downloadFile
}


